<template>
    <div class="position-relative">
        <footer class="footer pt-0 mt-5">
            <div class="footer_bg">
                <div class="footer_container container-fluid">
                    <div class="row">
                        <div class="col-md-4 text-center">
                            <img class="w-180px mt-5" :src="require('@/assets/images/nta-logo-white.png')" alt="">
                        </div>
                        <div class="col-md-4 text-center">
                            <img class="w-100px mt-5" :src="require('@/assets/images/qc.png')" alt="">
                        </div>
                        <div class="col-md-4">
                            <div>
                                <p class="text-start text-white mb-0">{{$t('follow_us')}}</p>
                            </div>
                            <div class="text-start">
                                <a href="https://www.facebook.com/NTAEgy" target="_blank" class="text-white footer_social">
                                    <i class="uil uil-facebook-f text-white fs-4"></i>
                                </a>
                                <a href="https://twitter.com/NTAEgy" target="_blank" class="text-white footer_social">
                                    <i class="uil uil-twitter-alt text-white fs-4"></i>
                                </a>
                                <a href="https://www.youtube.com/c/NTAEgy" target="_blank" class="text-white footer_social">
                                    <i class="uil uil-youtube text-white fs-4"></i>
                                </a>
                                <a href="https://www.linkedin.com/school/ntaegy" target="_blank" class="text-white footer_social">
                                    <i class="uil uil-linkedin-alt text-white fs-4"></i>
                                </a>
                                <a href="https://www.instagram.com/ntaegy/" target="_blank" class="text-white footer_social">
                                    <i class="uil uil-instagram text-white fs-4"></i>
                                </a>
                            </div>
                            <a href="mailto:info@nta.eg" class="text-white">
                                <i class="uil uil-fast-mail text-white fs-3"></i>
                                {{$t('send_mail')}} :  info@nta.eg
                            </a>

                        </div>
                    </div>
                </div>

                <div class="footer_container container container-small grid d-none">

                    <div class="footer_linkss text-start">
                        <p class="text-start text-white">{{$t('download_app')}}</p>
                        <!--<div class="row">-->
                        <!--<div class="col-12 text-start  mb-2">-->
                        <!--<a href="">-->
                        <!--<img :src="require('@/assets/images/ios.jpg')" class="w-50" alt="">-->
                        <!--</a>-->
                        <!--</div>-->
                        <!--<div class="col-12 text-start">-->
                        <!--<a href="">-->
                        <!--<img :src="require('@/assets/images/android.jpg')" class="w-50" alt="">-->
                        <!--</a>-->
                        <!--</div>-->
                        <!--</div>-->

                    </div>

                    <div class="text-center">
                        <div style="width: 120px" class="text-center m-auto">
                            <img :src="require('@/assets/images/qc.png')" alt="">
                        </div>
                    </div>

                    <div class="footer_socials">
                        <div>

                            <p class="text-start text-white">{{$t('contact_us_p')}}</p>
                        </div>
                        <div class="text-start">
                            <a href="https://www.facebook.com/NTAEgy" target="_blank" class="footer_social">
                                <i class="uil uil-facebook-f"></i>
                            </a>
                            <a href="https://www.youtube.com/c/NTAEgy" target="_blank" class="footer_social">
                                <i class="uil uil-youtube"></i>
                            </a>
                            <a href="https://www.linkedin.com/school/ntaegy" target="_blank" class="footer_social">
                                <i class="uil uil-linkedin-alt"></i>
                            </a>
                            <a href="https://www.instagram.com/ntaegy/" target="_blank" class="footer_social">
                                <i class="uil uil-instagram"></i>
                            </a>
                            <a href="https://twitter.com/NTAEgy" target="_blank" class="footer_social">
                                <i class="uil uil-twitter-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="footer_copy fs-8 text-white">
                    <div style="line-height: 5px">{{$t('copyrights')}}</div>
                    {{$t('copyrights_p')}} {{(new Date()).getFullYear()}} ©
                </div>
            </div>
        </footer>
    </div>
</template>

<script lang='ts'>
  import { defineComponent, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  export default defineComponent({
    name: 'header-menu',
    components: {},
    mounted() {

    },
    methods: {},
    setup() {

    },
  });
</script>

<style scoped>

</style>